var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDabio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 364.502,
    height: 57.872,
    viewBox: "0 0 364.502 57.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8",
    "data-name": "Rect\\xE1ngulo 8",
    width: 364.502,
    height: 57.872,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_dabio",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M126.861,26.221c6.159-.314,12.2.533,18.174-.5,3.929-.681,5.524-2.711,5.38-6.2-.129-3.131-2.1-5.044-5.927-5.435-5.7-.582-11.423-.181-17.137-.223a1.962,1.962,0,0,0-.57.228q0,5.343,0,10.664c0,.4.04.8.076,1.47m0,21.242c6.978-.378,13.826.586,20.609-.635,3.307-.6,4.9-2.6,4.949-5.64.051-3.263-1.444-5.251-4.872-5.965-6.762-1.408-13.617-.646-20.437-.659-.068,0-.137.107-.248.2ZM152.576,29.8c3.432,1.277,6.121,3.158,7.792,6.208,4.5,8.218-.122,17.135-10.028,19.185a38.844,38.844,0,0,1-7.371.758c-7.972.093-15.946.037-23.92.032-.527,0-1.166.022-1.166.022V5.318h3.611c7.478,0,14.955-.007,22.433.017A19.827,19.827,0,0,1,154.02,7.9a12.285,12.285,0,0,1,.243,20.868c-.484.3-.97.6-1.687,1.036",
    transform: "translate(-31.32 -1.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M227.5,27.485c-7.453-.043-12.36,4.686-12.419,11.966-.062,7.5,4.806,12.543,12.151,12.591,7.522.05,12.441-4.78,12.466-12.237s-4.744-12.278-12.2-12.32m-.174,32.9C214.842,60.358,205.76,51.6,205.8,39.626c.04-11.9,9.288-20.661,21.732-20.6,12.528.065,21.538,8.771,21.505,20.78-.033,11.939-9.176,20.606-21.709,20.578",
    transform: "translate(-54.678 -5.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M195.355,5.938A6.184,6.184,0,0,1,183,5.884a6.184,6.184,0,0,1,12.356.054",
    transform: "translate(-48.62 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 8.974,
    height: 39.467,
    transform: "translate(135.8 14.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M4.093,35.741c-.012,9.633,6.359,16.425,15.4,16.414,9.214-.012,15.862-6.788,15.886-16.193.025-9.7-6.485-16.51-15.8-16.534-9.1-.023-15.469,6.685-15.481,16.313M35.437,24.752V1.927h3.8V55.113l-3.793.014V46.782a18.421,18.421,0,0,1-14.784,9.075A17.934,17.934,0,0,1,4.929,49.675C-2.419,41.327-1.363,26.828,6.845,19.86c7.571-6.425,21.993-6,28.592,4.891",
    transform: "translate(0 -0.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M91.822,41.318c-6.438-.558-12.869-1.79-19.265.132-3.647,1.095-5.394,3.776-5.366,7.648a7.287,7.287,0,0,0,5.488,7.3,17.106,17.106,0,0,0,7.08.588c7.07-.7,13.269-8.568,12.065-15.67m-.034-3.5c1.568-7.169-2.958-13.016-10.115-13.456A20.914,20.914,0,0,0,67.3,28.7l-2.041-3a22.9,22.9,0,0,1,16.42-5.09c9.743.631,14.418,5.741,14.426,15.547.007,7.793.086,24.066.086,24.066s-2.635-.046-4.073-.016V52.064c-2.627,3.774-5.454,6.521-9.331,7.773-5.643,1.824-11.209,1.782-15.932-2.312-3.923-3.4-4.407-7.984-2.894-12.649,1.63-5.024,5.785-7,10.678-7.632,5.041-.648,10.07-.066,15.092.386.665.06,1.331.125,2.053.192",
    transform: "translate(-16.784 -5.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M290.152,37.814c1.936,0,3.111-.761,3.111-2.212v-.046c0-1.36-1.083-2.166-3.318-2.166H285.45v4.424Zm-.83-6.821c1.82,0,3.042-.714,3.042-2.19v-.046c0-1.267-1.013-2.051-2.834-2.051H285.45v4.287Zm-6.66-6.8H289.9a5.827,5.827,0,0,1,4.218,1.429A3.612,3.612,0,0,1,295.2,28.3v.046a3.841,3.841,0,0,1-2.3,3.6c1.89.645,3.2,1.729,3.2,3.918V35.9c0,2.881-2.373,4.425-5.969,4.425h-7.466Z",
    transform: "translate(-75.099 -6.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M305.212,27.957H308V40.126h-2.788Zm-.115-4.515h3v2.65h-3Z",
    transform: "translate(-81.06 -6.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M323.442,35.653v-.046a3.761,3.761,0,0,0-3.733-3.918,3.652,3.652,0,0,0-3.665,3.871v.047a3.771,3.771,0,0,0,3.71,3.918,3.67,3.67,0,0,0,3.687-3.872m-10.186,0v-.046a6.489,6.489,0,0,1,12.975-.047v.047a6.362,6.362,0,0,1-6.521,6.337,6.293,6.293,0,0,1-6.453-6.292",
    transform: "translate(-83.228 -7.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M343.932,34.015v-.046a3.652,3.652,0,0,0-3.526-3.895,3.567,3.567,0,0,0-3.5,3.895v.046a3.62,3.62,0,0,0,3.5,3.894,3.665,3.665,0,0,0,3.526-3.894m-9.841,0v-.046c0-4.033,2.743-6.314,5.646-6.314a5.036,5.036,0,0,1,4.148,2.143V23.253h2.789V40.076h-2.789V38.048a4.871,4.871,0,0,1-4.148,2.282c-2.857,0-5.646-2.282-5.646-6.314",
    transform: "translate(-88.763 -6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M356.3,27.957h2.788V40.126H356.3Zm-.115-4.515h3v2.65h-3Z",
    transform: "translate(-94.632 -6.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M363.681,29.592h3l3.272,8.942,3.3-8.942h2.927l-4.978,12.26h-2.512Z",
    transform: "translate(-96.625 -7.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M391.237,34.732c-.184-1.8-1.245-3.2-3.088-3.2-1.706,0-2.9,1.314-3.158,3.2Zm-9.011.9v-.046a6.039,6.039,0,0,1,5.946-6.337c3.871,0,5.83,3.042,5.83,6.545,0,.253-.023.507-.046.784h-8.942a3.4,3.4,0,0,0,3.5,3.089,4.421,4.421,0,0,0,3.3-1.452l1.636,1.452a6.157,6.157,0,0,1-4.978,2.282,6.071,6.071,0,0,1-6.245-6.315",
    transform: "translate(-101.552 -7.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M402.246,29.507h2.788v2.742a4.314,4.314,0,0,1,4.309-2.973v2.95h-.162c-2.442,0-4.147,1.59-4.147,4.816v4.633h-2.788Z",
    transform: "translate(-106.871 -7.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M414.012,40.095l1.245-1.889a6.831,6.831,0,0,0,3.987,1.5c1.2,0,1.89-.507,1.89-1.313v-.046c0-.945-1.291-1.267-2.72-1.706-1.8-.507-3.8-1.245-3.8-3.572v-.046c0-2.305,1.913-3.71,4.332-3.71a8.44,8.44,0,0,1,4.471,1.383l-1.107,1.983a7.052,7.052,0,0,0-3.434-1.153c-1.083,0-1.706.507-1.706,1.222v.046c0,.875,1.314,1.244,2.743,1.705,1.775.553,3.78,1.359,3.78,3.549v.046c0,2.558-1.982,3.826-4.517,3.826a8.548,8.548,0,0,1-5.162-1.82",
    transform: "translate(-109.997 -7.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M431.386,27.957h2.788V40.126h-2.788Zm-.115-4.515h3v2.65h-3Z",
    transform: "translate(-114.582 -6.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M449.333,34.015v-.046a3.652,3.652,0,0,0-3.526-3.895,3.567,3.567,0,0,0-3.5,3.895v.046a3.62,3.62,0,0,0,3.5,3.894,3.665,3.665,0,0,0,3.526-3.894m-9.841,0v-.046c0-4.033,2.743-6.314,5.646-6.314a5.036,5.036,0,0,1,4.148,2.143V23.253h2.789V40.076h-2.789V38.048a4.871,4.871,0,0,1-4.148,2.282c-2.858,0-5.646-2.282-5.646-6.314",
    transform: "translate(-116.767 -6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M468.733,36.6a7.957,7.957,0,0,0-2.788-.484c-1.752,0-2.789.714-2.789,1.89v.046c0,1.152,1.037,1.8,2.351,1.8,1.844,0,3.227-1.037,3.227-2.558Zm-.069,5.093v-1.5a4.919,4.919,0,0,1-3.941,1.751c-2.3,0-4.332-1.314-4.332-3.756v-.046c0-2.7,2.1-3.987,4.932-3.987a10.239,10.239,0,0,1,3.365.507v-.231c0-1.682-1.06-2.6-3-2.6a8.483,8.483,0,0,0-3.48.761l-.76-2.235a10.433,10.433,0,0,1,4.632-1.014c3.6,0,5.347,1.89,5.347,5.139v7.213Z",
    transform: "translate(-122.319 -7.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M489.089,34.015v-.046a3.652,3.652,0,0,0-3.525-3.895,3.567,3.567,0,0,0-3.5,3.895v.046a3.62,3.62,0,0,0,3.5,3.894,3.665,3.665,0,0,0,3.525-3.894m-9.84,0v-.046c0-4.033,2.742-6.314,5.646-6.314a5.035,5.035,0,0,1,4.147,2.143V23.253h2.789V40.076h-2.789V38.048a4.871,4.871,0,0,1-4.147,2.282c-2.858,0-5.646-2.282-5.646-6.314",
    transform: "translate(-127.329 -6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M290.009,54.23v-.05a1.536,1.536,0,0,0-1.644-1.619,1.642,1.642,0,0,0-1.694,1.769v.05a3.111,3.111,0,0,0,1.021,2.167c1.52-.573,2.317-1.22,2.317-2.317m-.2,9.192-3.338-3.388a2.6,2.6,0,0,0-1.619,2.292v.05a2.168,2.168,0,0,0,2.441,2.043,4.132,4.132,0,0,0,2.517-1m2.142,2.192a7.856,7.856,0,0,1-5.106,1.944c-3.338,0-5.854-1.944-5.854-5.032v-.05c0-2.217,1.2-3.787,3.387-4.783a5.83,5.83,0,0,1-1.22-3.488v-.05c0-2.391,1.918-4.584,5.281-4.584,2.964,0,4.907,1.943,4.907,4.385v.05c0,2.341-1.5,3.711-3.662,4.559L292,60.882c.573-.9,1.146-1.918,1.694-2.989l2.815,1.544a32.26,32.26,0,0,1-2.292,3.687l2.566,2.566-2.815,1.968Z",
    transform: "translate(-74.655 -13.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M315.825,51.758H319.1l7.559,9.932V51.758h3.5V67.889H327.14l-7.813-10.255V67.889h-3.5Z",
    transform: "translate(-83.91 -13.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M348.164,62.029a2.649,2.649,0,0,0-2.6-2.627c-1.452,0-2.4,1.038-2.674,2.627Zm-8.711,1.037V63.02a6.149,6.149,0,0,1,6.107-6.429c4.125,0,6.015,3.2,6.015,6.706,0,.277-.023.6-.046.922h-8.6a2.865,2.865,0,0,0,3.019,2.42,4.05,4.05,0,0,0,3-1.267l2,1.774a6.525,6.525,0,0,1-11.5-4.079",
    transform: "translate(-90.188 -15.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M368.425,62.4v-.046a3.011,3.011,0,0,0-6.015,0V62.4a2.822,2.822,0,0,0,3,2.858,2.855,2.855,0,0,0,3.019-2.858m-8.9,9.218,1.2-2.627a8.06,8.06,0,0,0,4.171,1.13c2.4,0,3.526-1.153,3.526-3.365v-.6a4.831,4.831,0,0,1-4.033,2.005,5.425,5.425,0,0,1-5.485-5.761v-.046a5.438,5.438,0,0,1,5.485-5.761,5,5,0,0,1,3.987,1.844V56.822h3.5v9.564a6.627,6.627,0,0,1-1.567,4.863c-1.153,1.152-2.927,1.66-5.324,1.66a11.718,11.718,0,0,1-5.462-1.291",
    transform: "translate(-95.356 -15.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M390.092,63.066V63.02a3.282,3.282,0,0,0-3.249-3.41,3.165,3.165,0,0,0-3.2,3.365v.046a3.282,3.282,0,0,0,3.249,3.412,3.165,3.165,0,0,0,3.2-3.365m-9.91,0V63.02a6.689,6.689,0,0,1,13.366-.046v.046a6.689,6.689,0,0,1-13.366.046",
    transform: "translate(-101.009 -15.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M401.174,63.066V63.02a6.341,6.341,0,0,1,6.476-6.429,6.074,6.074,0,0,1,4.932,2.074l-2.143,2.3a3.61,3.61,0,0,0-2.812-1.359,3.157,3.157,0,0,0-3,3.365v.046a3.166,3.166,0,0,0,3.135,3.412,3.913,3.913,0,0,0,2.834-1.314l2.051,2.074A6.22,6.22,0,0,1,407.6,69.45a6.307,6.307,0,0,1-6.43-6.383",
    transform: "translate(-106.586 -15.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M420.251,55.288h3.5V67.64h-3.5Zm-.093-4.471h3.687v3.111h-3.687Z",
    transform: "translate(-111.63 -13.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M438.791,63.066V63.02a3.282,3.282,0,0,0-3.249-3.41,3.165,3.165,0,0,0-3.2,3.365v.046a3.282,3.282,0,0,0,3.249,3.412,3.165,3.165,0,0,0,3.2-3.365m-9.91,0V63.02a6.689,6.689,0,0,1,13.367-.046v.046a6.689,6.689,0,0,1-13.367.046",
    transform: "translate(-113.947 -15.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M449.371,67.554l1.5-2.305a6.986,6.986,0,0,0,3.895,1.475c1.014,0,1.475-.369,1.475-.922v-.046c0-.761-1.2-1.014-2.558-1.429-1.729-.507-3.688-1.314-3.688-3.71v-.046c0-2.511,2.028-3.918,4.518-3.918a8.547,8.547,0,0,1,4.609,1.429l-1.336,2.42a7.317,7.317,0,0,0-3.341-1.152c-.853,0-1.291.369-1.291.853v.046c0,.691,1.176,1.014,2.512,1.475,1.729.576,3.733,1.406,3.733,3.665v.046c0,2.743-2.051,3.987-4.725,3.987a8.655,8.655,0,0,1-5.3-1.867",
    transform: "translate(-119.391 -15.052)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDabio);
export default __webpack_public_path__ + "static/media/logo_dabio.52c494b029412f603cea798ef9d77d87.svg";
export { ForwardRef as ReactComponent };